// import * as API  from '@libs/MPAAPI/index';

class ComponentManifest extends Manifest {
	static async instantiate(
		localRootComponent: Component<any, any>,
		treeNodes: Component.TreeNode.RecursiveNode.TNode<any>[],
		topChilds: Component<any, any>[]
	): Promise<Component<any, any>> {
		for (const childTreeNode of treeNodes) {
			const descriptor = {
				type: childTreeNode.type,
				id: childTreeNode.id,
				configuration: childTreeNode.configuration || {},
				slot: childTreeNode.slot,
				tree: localRootComponent,
				...(childTreeNode.isSlot ? {
					isSlot: true,
					declaredSlot: childTreeNode.declaredSlot
				} as const : {
					isSlot: false
				} as const)
			};
			const childComponent = await localRootComponent.component_instantiateInnerChild(descriptor);
			topChilds.push(childComponent);
			const stack: [Component<any, any>, Component.TreeNode.RecursiveNode.TNode<any>, string][] = childTreeNode.childs.map(x => [
				childComponent,
				x,
				childTreeNode.id
			]);
			while (stack.length) {
				const [parent, node, path] = <typeof stack[0]>stack.shift();
				const component = await parent.component_instantiateOuterChild({
					type: node.type,
					id: node.id,
					configuration: node.configuration || {},
					slot: node.slot || 'default',
					tree: localRootComponent,
					...(node.isSlot ? {
						isSlot: true,
						declaredSlot: node.declaredSlot,
					} : {
						isSlot: false
					})
				});
				for (const child of node.childs) {
					stack.push([component, child, path + '.' + child.id]);
				}
			}
		}
		return localRootComponent;
	};

	declare readonly inheritedManifest: ComponentManifest | null;
	declare readonly type: 'component';

	async instantiate(parent: Component<any, any>): Promise<Component<any, any>> {
		await ComponentManifest.instantiate(parent, this.treeNodes, []);
		return parent;
	};

	protected constructor(
		source: string,
		initialXML: Element,
		type: string,
		inheritedManifest: ComponentManifest | null
	) {
		super(source, initialXML, type, inheritedManifest);
		this.configurations.template = {};
	};
};
namespace ComponentManifest {

}
export default ComponentManifest;
//@ts-ignore
ComponentManifest.prototype.type = 'component';
import Component from '../Component';
import Manifest  from '../Manifest';

Manifest.ComponentManifest = ComponentManifest;
